/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Creder } from './Creder';
import {
    CrederFromJSON,
    CrederFromJSONTyped,
    CrederToJSON,
} from './Creder';

/**
 * 
 * @export
 * @interface CompleteCredentialIssuanceWorkflowRequest
 */
export interface CompleteCredentialIssuanceWorkflowRequest {
    /**
     * 
     * @type {Creder}
     * @memberof CompleteCredentialIssuanceWorkflowRequest
     */
    creder?: Creder;
}

/**
 * Check if a given object implements the CompleteCredentialIssuanceWorkflowRequest interface.
 */
export function instanceOfCompleteCredentialIssuanceWorkflowRequest(value: object): boolean {
    return true;
}

export function CompleteCredentialIssuanceWorkflowRequestFromJSON(json: any): CompleteCredentialIssuanceWorkflowRequest {
    return CompleteCredentialIssuanceWorkflowRequestFromJSONTyped(json, false);
}

export function CompleteCredentialIssuanceWorkflowRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteCredentialIssuanceWorkflowRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'creder': json['creder'] == null ? undefined : CrederFromJSON(json['creder']),
    };
}

export function CompleteCredentialIssuanceWorkflowRequestToJSON(value?: CompleteCredentialIssuanceWorkflowRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'creder': CrederToJSON(value['creder']),
    };
}

